export const PodcastLinks = {
  spotify: 'https://open.spotify.com/show/6p5wjidjUFg2DgXs2xqhIT',

  apple: 'https://podcasts.apple.com/in/podcast/indian-conflict-resolution/id1531189437',

  pocketCast: 'https://pca.st/3uyv69hy',

  google: 'https://podcasts.google.com/feed/aHR0cHM6Ly9hbmNob3IuZm0vcy8yN2ZiMTY2Yy9wb2RjYXN0L3Jzcw==',

  radioPublic: 'https://radiopublic.com/indian-conflict-resolution-WdqZq7',

  overcast: 'https://overcast.fm/itunes1531189437/indian-conflict-resolution',
}